import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "bg-accent overflow-hidden" }
const _hoisted_2 = { class: "section" }
const _hoisted_3 = { class: "relative" }
const _hoisted_4 = {
  ref: "track",
  class: "flex gap-5 overflow-x-auto scrollbar-hide pb-2 snap-x snap-mandatory"
}
const _hoisted_5 = { class: "flex gap-0.5 mb-3" }
const _hoisted_6 = { class: "text-cream-100/90 leading-relaxed text-sm mb-5" }
const _hoisted_7 = { class: "flex items-center gap-3 pt-4 border-t border-white/10" }
const _hoisted_8 = { class: "w-10 h-10 rounded-full bg-brand flex items-center justify-center text-white font-bold font-display text-base flex-shrink-0" }
const _hoisted_9 = { class: "font-semibold text-white text-sm leading-tight" }
const _hoisted_10 = { class: "text-cream-200/50 text-xs" }
const _hoisted_11 = { class: "text-center mt-10" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[4] || (_cache[4] = _createElementVNode("div", { class: "text-center max-w-xl mx-auto mb-10" }, [
        _createElementVNode("p", { class: "text-brand-300 font-semibold text-sm uppercase tracking-widest mb-1" }, "What Clients Say"),
        _createElementVNode("h2", { class: "font-display text-3xl font-bold text-white mb-2" }, "Customer Reviews"),
        _createElementVNode("p", { class: "text-cream-200/60 text-base" }, "Real feedback from people we cook for every day")
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.approved, (t) => {
            return (_openBlock(), _createElementBlock("div", {
              key: t.id,
              class: "flex-shrink-0 w-72 sm:w-80 md:w-96 snap-start bg-white/10 backdrop-blur-sm rounded-3xl p-4 sm:p-6 border border-white/10 hover:bg-white/15 transition-colors duration-200"
            }, [
              _createElementVNode("div", _hoisted_5, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (i) => {
                  return _createElementVNode("span", {
                    key: i,
                    class: _normalizeClass(["text-lg", i <= t.rating ? 'text-yellow-400' : 'text-white/20'])
                  }, "★", 2)
                }), 64))
              ]),
              _createElementVNode("p", _hoisted_6, "\"" + _toDisplayString(t.message) + "\"", 1),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, _toDisplayString(t.name.charAt(0)), 1),
                _createElementVNode("div", null, [
                  _createElementVNode("p", _hoisted_9, _toDisplayString(t.name), 1),
                  _createElementVNode("p", _hoisted_10, _toDisplayString(t.location) + " · " + _toDisplayString(_ctx.formatDate(t.date)), 1)
                ])
              ])
            ]))
          }), 128))
        ], 512),
        _cache[0] || (_cache[0] = _createElementVNode("div", { class: "pointer-events-none absolute inset-y-0 left-0 w-4 sm:w-6 lg:w-8 bg-gradient-to-r from-accent to-transparent" }, null, -1)),
        _cache[1] || (_cache[1] = _createElementVNode("div", { class: "pointer-events-none absolute inset-y-0 right-0 w-4 sm:w-6 lg:w-8 bg-gradient-to-l from-accent to-transparent" }, null, -1))
      ]),
      _createElementVNode("div", _hoisted_11, [
        _cache[3] || (_cache[3] = _createElementVNode("p", { class: "text-cream-200/50 text-sm mb-3" }, "Had a great meal? Tell us about it!", -1)),
        _createVNode(_component_router_link, {
          to: "/contact#review",
          class: "btn-primary text-sm px-6 py-2.5"
        }, {
          default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
            _createTextVNode(" Leave a Review ", -1)
          ]))]),
          _: 1
        })
      ])
    ])
  ]))
}